import { Button } from '@/components/design-system/Button';
import { IconWrapper } from '@/components/ui/IconWrapper';
import { SettingOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

import type { Notification } from '../types/Notifications.types';
import { NotificationItem } from './NotificationItem';
import { NotificationsEmpty } from './NotificationsEmpty';

interface NotificationsListProps {
  notifications: Notification[];
  onNotificationClick: (notification: Notification) => void;
  onMarkAllAsRead: () => void;
}

export const NotificationsList: React.FC<NotificationsListProps> = ({ notifications, onNotificationClick }) => {
  const { t } = useTranslation();

  if (notifications.length === 0) {
    return <NotificationsEmpty />;
  }

  return (
    <div className="flex flex-col">
      <div className="flex items-center justify-between pt-3 pr-2.5 pl-3.5">
        <h4 className="text-typography-600 text-sm font-semibold">{t('header.notifications.title')}</h4>

        <Button variant="icon" size="icon" className="h-8 w-8 rounded-full">
          <IconWrapper icon={SettingOutlined} className="[&_svg]:text-typography-600 transition-colors" />
        </Button>
      </div>

      <div className="nav-scrollbar-expanded z-1 max-h-[300px] overflow-y-auto pl-3">
        <div className="bg-background-400 z-2 flex flex-col gap-2 rounded-lg p-2">
          {notifications.map((notification) => (
            <NotificationItem key={notification.id} notification={notification} onClick={onNotificationClick} />
          ))}
        </div>
      </div>

      <div className="border-0 px-3 py-2">
        <Button variant="primary" size="fullWidth" className="border-0">
          {t('header.notifications.dashboard')}
        </Button>
      </div>
    </div>
  );
};
